<template>
  <div class="container stats">
    <h2>סיכום ההתקדמות שלך</h2>
    <div class="columns is-centered is-multiline">
      <div class="column">
        <img
          src="@/assets/images/stats/level1.png"
          alt=""
          v-if="averageLevel === '1' || averageLevel === '1-2'"
        />
        <img
          src="@/assets/images/stats/level2.png"
          alt=""
          v-if="averageLevel === '2'"
        />
        <img
          src="@/assets/images/stats/level3.png"
          alt=""
          v-if="averageLevel === '2-3'"
        />
        <h4>רמה ממוצעת</h4>
        <p>{{ averageLevel }}</p>
        <span>מצויין- שמרת על הרמה שלך!</span>
      </div>

      <div class="column">
        <img src="@/assets/images/stats/stat1.png" alt="" />
        <h4>כמה תרגלת השבוע?</h4>
        <p>{{ weeklyViews.length }} אימונים</p>
        <span>{{ weeklySubTxt }}</span>
      </div>

      <div class="column">
        <img src="@/assets/images/stats/stat2.png" alt="" />
        <h4>{{ monthlyViews.length }} אימונים החודש</h4>
        <p></p>
        <span>כולם נספרו בשיעורי הקהילה</span>
      </div>

      <div class="column inverted">
        <img src="@/assets/images/stats/stat3.png" alt="" />
        <h4>שיעורים בקהילה</h4>
        <p>סה"כ {{ $store.state.user.totalViews }}</p>
        <span>{{ giftSubsTxt }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      goal: 5000,
      giftSubs: 1,
    };
  },
  computed: {
    averageLevel() {
      const lvl = this.$store.getters.averageLevel;
      let level = "1";
      if (lvl > 1.2) {
        level = "1-2";
      }

      if (lvl > 2) {
        level = "2";
      }

      if (lvl > 2.41) {
        level = "2-3";
      }
      return level;
    },
    left() {
      return this.goal - this.$store.state.user.totalViews;
    },
    giftSubsTxt() {
      let str = `עוד ${this.left} להענקת מנוי חינם`;

      if (this.giftSubs > 1) {
        str = `עוד ${this.left} להענקת ${this.giftSubs} מנויים חינם`;
      }
      return str;
    },
    sunday() {
      let now = new Date(Date.now());
      now = new Date(now.setHours(0, 0, 0, 0));
      while (now.getDay() !== 0) {
        now.setDate(now.getDate() - 1);
      }
      return now;
    },
    monthlyViews() {
      const output = this.$store.state.user.myViews.filter(view => {
        const now = new Date(Date.now()).getMonth();
        const v = new Date(view.date).getMonth();
        if (now === v) {
          return true;
        }
        return false;
      });
      return output;
    },
    weeklyViews() {
      const output = this.$store.state.user.myViews.filter(view => {
        if (Date.parse(view.date) >= Date.parse(this.sunday)) {
          return true;
        }
        return false;
      });
      return output;
    },
    lastWeekViews() {
      const lastSunday = new Date();
      lastSunday.setDate(this.sunday.getDate() - 7);
      const output = this.$store.state.user.myViews.filter(view => {
        if (
          Date.parse(view.date) < Date.parse(this.sunday) &&
          Date.parse(view.date) >= lastSunday
        ) {
          return true;
        }
        return false;
      });
      return output;
    },
    weeklySubTxt() {
      let str = "זה הזמן לעלות על המזרן ולהוסיף עוד שיעור השבוע";
      if (this.weeklyViews.length > this.lastWeekViews.length) {
        let deficit = this.weeklyViews.length - this.lastWeekViews.length;
        str = `מדהים! עלייה של ${deficit}השבוע`;
      }

      if (this.weeklyViews.length == this.lastWeekViews.length) {
        str = "אין שינוי השבוע... אנחנו מחכים לך על המזרן";
      }
      return str;
    },
  },
  mounted() {
    while (this.goal < this.$store.state.user.totalViews) {
      this.goal = this.goal + 5000;
      this.giftSubs += 1;
    }
  },
};
</script>

<style lang="scss">
.container.stats {
  text-align: center;
  // background-color: #ffffff;
  margin-bottom: 1em;
  h2 {
    font-size: 1.3rem;
    font-weight: bold;
    text-align: right;
    padding-right: 1rem;
    margin: 1rem 0;
  }
  h4 {
    font-size: 1.2em;
    font-weight: bold;
  }
  .columns {
    display: flex;
  }
  .column {
    background-color: #fcfcfc;
    max-width: 25%;
    min-width: 160px;
    box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.25);
    margin: 1rem;
    color: #666b83;
    img {
      max-width: 30px;
      height: auto;
    }
    span {
      font-size: 0.8rem;
    }
  }
  .inverted {
    color: #fcfcfc;
    background-color: #666b83;
  }
  @media screen and (min-width: 930px) {
    .container.stats {
    }
  }
}
</style>